import { useEffect, useMemo, useState } from 'react';
import { adminApi } from '../../api/admin.js';

export default function RolesMatrix() {
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [activeRole, setActiveRole] = useState(null);
  const [grants, setGrants] = useState(new Set());
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);

  function refresh() {
    adminApi.roles().then((d) => {
      setRoles(d?.items || []);
      if (!activeRole && d?.items?.[0]) {
        setActiveRole(d.items[0]);
        setGrants(new Set(d.items[0].permissions.map((p) => p.id)));
      }
    });
    adminApi.permissions().then((d) => setPermissions(d?.items || []));
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(refresh, []);

  function selectRole(r) {
    setActiveRole(r);
    setGrants(new Set(r.permissions.map((p) => p.id)));
  }

  function toggle(id) {
    const next = new Set(grants);
    if (next.has(id)) next.delete(id); else next.add(id);
    setGrants(next);
  }

  async function save() {
    setInfo(null); setError(null);
    try {
      await adminApi.setRolePermissions(activeRole.id, [...grants]);
      setInfo('Saved');
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  // Group permissions by resource for the matrix.
  const grouped = useMemo(() => {
    const m = new Map();
    for (const p of permissions) {
      if (!m.has(p.resource)) m.set(p.resource, []);
      m.get(p.resource).push(p);
    }
    return [...m.entries()].sort();
  }, [permissions]);

  return (
    <section>
      <header className="page-header"><h1>Roles &amp; Permissions</h1></header>
      {error && <div className="alert error">{error}</div>}
      {info && <div className="alert info">{info}</div>}

      <div className="grid-2" style={{ gridTemplateColumns: '260px 1fr' }}>
        <div className="card">
          <h3>Roles</h3>
          <ul className="suite-list">
            {roles.map((r) => (
              <li key={r.id} className={activeRole?.id === r.id ? 'active' : ''} onClick={() => selectRole(r)}>
                {r.name} <span className="muted small">({r.permissions.length})</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="card">
          {!activeRole ? <div className="muted">Select a role.</div> : (
            <>
              <header className="page-header">
                <h3>{activeRole.name}</h3>
                <button className="btn primary" onClick={save}>Save</button>
              </header>
              <p className="muted small">{grants.size} of {permissions.length} permissions granted.</p>
              <div className="perm-matrix">
                {grouped.map(([resource, perms]) => (
                  <div key={resource} className="perm-group">
                    <h4>{resource}</h4>
                    <div className="perm-row">
                      {perms.map((p) => (
                        <label key={p.id} className={`perm-pill ${grants.has(p.id) ? 'on' : ''}`}>
                          <input type="checkbox" checked={grants.has(p.id)} onChange={() => toggle(p.id)} />
                          <span>{p.action}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
